var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5167_81747",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5167_81747)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 6.00008V4.00008C10.6687 2.89608 11.5627 2.00208 12.6667 2.00008C13.7707 2.00208 14.6647 2.89608 14.6667 4.00008V11.3334H10.6667V6.00008ZM9.33333 13.3334C9.33333 13.7007 9.03467 14.0001 8.66667 14.0001H2C1.632 14.0001 1.33333 13.7007 1.33333 13.3334V6.00008V4.00008C1.33533 2.89608 2.22933 2.00208 3.33333 2.00008H10.0153C9.59333 2.55875 9.33333 3.24608 9.33333 4.00008V6.00008V13.3334ZM12.6667 0.666748H3.33333C1.492 0.667415 0 2.15875 0 4.00008V6.00008V13.3334C0 14.4381 0.896 15.3334 2 15.3334H8.66667C9.77067 15.3334 10.6667 14.4381 10.6667 13.3334V12.6667H15.3333C15.7 12.6667 16 12.3667 16 12.0001V4.00008C16 2.15875 14.508 0.667415 12.6667 0.666748ZM7.33333 7.33342H3.33333C2.96667 7.33342 2.66667 7.63342 2.66667 8.00008C2.66667 8.36675 2.96667 8.66675 3.33333 8.66675H7.33333C7.7 8.66675 8 8.36675 8 8.00008C8 7.63342 7.7 7.33342 7.33333 7.33342ZM7.33333 4.66675H3.33333C2.96667 4.66675 2.66667 4.96675 2.66667 5.33341C2.66667 5.70008 2.96667 6.00008 3.33333 6.00008H7.33333C7.7 6.00008 8 5.70008 8 5.33341C8 4.96675 7.7 4.66675 7.33333 4.66675ZM4.66667 10.0001H3.33333C2.96667 10.0001 2.66667 10.3001 2.66667 10.6667C2.66667 11.0334 2.96667 11.3334 3.33333 11.3334H4.66667C5.03333 11.3334 5.33333 11.0334 5.33333 10.6667C5.33333 10.3001 5.03333 10.0001 4.66667 10.0001Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperList);
export default __webpack_public_path__ + "static/media/paper_list.be5e5d81ffdd0b881c68a1fc34d2ba5c.svg";
export { ForwardRef as ReactComponent };